/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Unarchive_ConfirmInputs */

const fr_vehicle_action_unarchive_confirm = /** @type {(inputs: Vehicle_Action_Unarchive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir désarchiver ce véhicule ?`)
};

const en_vehicle_action_unarchive_confirm = /** @type {(inputs: Vehicle_Action_Unarchive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to unarchive this vehicle?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to unarchive this vehicle?" |
*
* @param {Vehicle_Action_Unarchive_ConfirmInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_unarchive_confirm = /** @type {((inputs?: Vehicle_Action_Unarchive_ConfirmInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Unarchive_ConfirmInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_unarchive_confirm(inputs)
	return en_vehicle_action_unarchive_confirm(inputs)
});